import Global from '../../js/constant.js'

const core = {
  state: {
    account : null,
    autoId : null,
    host:null,
    loginFlg: false,
    mail : null,
    sessionId : null,
    temporaryAccount : null,
  },
  getters: {
    account(state) { return state.account },
    autoId(state) { return state.autoId },
    host(state) { return state.host },
    loginFlg(state) { return state.loginFlg },
    mail(state) { return state.mail },
    sessionId(state) { return state.sessionId },
    temporaryAccount(state) { return state.temporaryAccount },
  },
  mutations: {
    setAccount (state, value) {
      state.account = value
      state.account['name'] = state.account.last_name + state.account.first_name
    },
    setAutoId (state, value) {
      state.autoId = value
    },
    setHost(state, value) {
      state.host = value
    },
    setLoginFlg(state, value) {
      state.loginFlg = value
    },
    setSessionId(state, value) {
      state.sessionId = value
    },
    setMail(state, value) {
      state.mail = value
    },
    setTemporaryAccount (state, value) {
      state.temporaryAccount = value
    },
    restore (state, { sessionId, autoId, account, temporaryAccount, mail, clientErrors, host }) {
      if ( state.sessionId == null ) {
        state.sessionId = sessionId
      }
      state.autoId = autoId
      state.account = account
      state.temporaryAccount = temporaryAccount
      state.mail = mail
      state.clientErrors = clientErrors
      state.host = host
    },
    initState (state) {
      state.loginFlg = false
      // state.sessionId = null
      state.autoId = null
      state.account = null
      state.host = null
      state.mail = null
      state.clientErrors = null
    }
  },
  actions: {
    save ({state}) {
      const data = {
        sessionId: state.sessionId,
        autoId: state.autoId,
        account: state.account,
        temporaryAccount: state.temporaryAccount, 
        mail: state.mail,
        clientErrors: state.clientErrors,
        host: state.host,
      }
      localStorage.setItem(Global.session_key, JSON.stringify(data))
    },
    restore ({commit}) {
      const data = localStorage.getItem(Global.session_key)

      if (data) {
        commit('restore', JSON.parse(data))
      }
    },
    storageClear () {
      localStorage.clear()
    },
  },
  modules: {}
}
export default core